import {RouteConfig} from "vue-router";


const prefix = '/admin'
const adminRoutes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'admin-index',
        component: () => import("@/views/User/UserList.vue"),
        meta: {requiredRoles: ['ROLE_ADMIN']},
    },
    {
        path: '/user/list',
        name: 'user-list',
        component: () => import("@/views/User/UserList.vue"),
        meta: {requiredRoles: ['ROLE_ADMIN']},
    },
    {
        path: '/user/edit/:id',
        name: 'user-edit',
        component: () => import("@/views/User/UserForm.vue"),
        meta: {requiredRoles: ['ROLE_ADMIN']},
    },
    {
        path: '/tenant/list',
        name: 'tenant-list',
        component: () => import("@/views/Tenant/TenantList.vue"),
        meta: {requiredRoles: ['ROLE_ADMIN']},
    },
    {
        path: '/role/list',
        name: 'role-list',
        component: () => import("@/views/Role/RoleList.vue"),
        meta: {requiredRoles: ['ROLE_ADMIN']},
    },

    {
        path: '/menu/manager',
        name: 'menu-manager',
        component: () => import("@/views/Admin/MenuManager.vue"),
        meta: {requiredRoles: ['ROLE_ADMIN']},
    },
    {
        path: '/api/manager',
        name: 'api-manager',
        component: () => import("@/views/Admin/ApiManager.vue"),
        meta: {requiredRoles: ['ROLE_ADMIN']},
    },


]
adminRoutes.forEach((route) => {
    route.path = prefix + route.path
})
export default adminRoutes;
